import type { IconGlyph } from '../icon';

import { iconRadarThick } from './radar-thick';

/**
 * Tractie `radar` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/radar.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconRadar: IconGlyph = {
  name: 'radar',
  path: 'M19.95 4.4a.504.504 0 0 0-.71-.02c-.2.19-.21.51-.02.71A9.98 9.98 0 0 1 21.99 12c0 5.51-4.49 10-10 10S2 17.51 2 12s4.22-9.71 9.5-9.97v2.5c-3.9.26-7 3.51-7 7.47s3.36 7.5 7.5 7.5a7.503 7.503 0 0 0 5.52-12.58c-.19-.2-.5-.21-.71-.03-.2.19-.22.5-.03.71A6.46 6.46 0 0 1 18.5 12c0 3.58-2.92 6.5-6.5 6.5S5.5 15.58 5.5 12s2.65-6.22 6-6.47v2.52C9.53 8.3 8 9.97 8 12c0 2.21 1.79 4 4 4s4-1.79 4-4c0-.88-.28-1.72-.81-2.41a.507.507 0 0 0-.7-.1c-.22.17-.26.48-.1.7.4.52.61 1.15.61 1.81 0 1.65-1.35 3-3 3s-3-1.35-3-3c0-1.48 1.08-2.71 2.5-2.95V12c0 .28.22.5.5.5s.5-.22.5-.5V1.5c0-.28-.22-.5-.5-.5C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11c0-2.84-1.08-5.54-3.05-7.6',
  selected: iconRadarThick,
};
